import React, { useState } from 'react';
import { ImTv } from "react-icons/im";
import { GiFilmProjector } from "react-icons/gi";
import { FcMindMap } from "react-icons/fc";
import { TbNetwork } from "react-icons/tb";




const ProximityTableSmall = (props) => {

    const colNames = [
        {variable: 'rank', display: 'Rank',},
        {variable: 'show_name', display: 'Title',},
        // {variable: 'content_type', display: 'Content Type',},
        // {variable: 'genre', display: 'Genre',},
        // {variable: 'genre_taxonomy', display: 'Genre Taxonomy',},
        // {variable: 'distance', display: 'Emotional Distance',},
    ];

    const hoverInit = {};
    for (let i=0; i<10; i++) {
        hoverInit[i] = false
    };
    const [hoverClicked, setHoverClicked] = useState(hoverInit);

    const handleShowHover = (event) => {
        const clickedId = event.target.id;
        // console.log(clickedId);
        setHoverClicked({
            [clickedId]: true,
        });
    };


    return (
        <div className='overflow-x-auto relative shadow-md'>
            <div className='flex justify-center -ml-10'>
                <div className='text-5xl'>
                    {/* <ImTv />
                    <RiMovie2Fill />
                    <BiCameraMovie className='font-bold text-xl' />
                    <ImVideoCamera />
                    <GiFilmProjector className='text-xl'/>
                    <FcFilm />
                    <FcLike /> */}
                    <FcMindMap />
                </div>
                <p className='text-xl font-bold mb-5 pt-5'>Top Proximity Content</p>
            </div>


            <table className='w-92 md:w-96 text-sm text-center text-gray-500'>
                <thead>
                    <tr>
                        {colNames.map((col,index)=>(
                            <th key={col.variable}
                                scope='col'
                                className='py-3 px-6'>
                                {col.display}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {[...Array(8).keys()].map((i)=>(
                        <tr key={i}
                            className={hoverClicked[i] ? `bg-gray-100` : `bg-white`}>
                            {colNames.map((col,index)=>(
                            <td id={i}
                                key={index.toFixed(1) + i.toFixed(1)}
                                onMouseOver={handleShowHover}
                                onClick={props.handleShowBtn}
                                className={`py-3 px-6`}>
                                <div className='flex'>
                                    {col.variable==='rank' &&
                                    (props.data[i].content_type==='Show' ?
                                    <ImTv className='w-5'/> : props.data[i].content_type==='Movie' ?
                                    <GiFilmProjector className='text-xl w-5' /> : props.data[i].content_type==='Network' ?
                                    <TbNetwork className='text-xl w-5' /> :
                                    null)}
                                    <button id={i}
                                            onMouseOver={handleShowHover}
                                            onClick={props.handleShowBtn}
                                            className= 'px-2 text-left'>
                                        {props.data[i][col.variable]}
                                    </button>
                                </div>
                            </td>
                    ))}
                        </tr>
                    ))}



                        {/* {colNames.map((col,index)=>(
                            <th key={index} scope='col' className='py-3 px-6'>
                                {props.data[index][col.variable]}
                            </th>
                        ))} */}
                </tbody>
            </table>
        </div>
     );
}

export default ProximityTableSmall;
